import React, { Component } from 'react'
import '../css/dashboard.css'
import Header from './Header'
import Sidebar from './Sidebar';
import Footer from './Footer';

export class FBLeadManager extends Component {
    render() {
        return (
            <div>
                <Header />
                <div className="container-fluid">
                    <div className="row">
                        <Sidebar active="/fb-lead-manager" />
                        <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
                            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                                <h1 className="h2">FB Lead Manager</h1>
                                <div className="btn-toolbar mb-2 mb-md-0">
                                <div className="btn-group mr-2">
                                    <button type="button" className="btn btn-sm btn-outline-secondary">Share</button>
                                    <button type="button" className="btn btn-sm btn-outline-secondary">Export</button>
                                </div>
                                <button type="button" className="btn btn-sm btn-outline-secondary dropdown-toggle">
                                    <span data-feather="calendar"></span>
                                    This week
                                </button>
                                </div>
                            </div>


                        </main>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default FBLeadManager
